/**
 * main.ts — Application entry point
 *
 * Initializes Vue, Pinia, Vue Router, and vue-i18n.
 * Mounts the app to #app.
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import { router } from './router';
import { i18n } from './i18n';

import './styles/global.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);

app.mount('#app');
